<button *ngIf="!hideBackButton" mat-icon-button class="left-content" (click)="backButtonClick.emit($event)">
	<span test-id="back-button" class="ico-arrow-back"></span>
</button>

<div
	class="projected-content"
	[ngClass]="{ 'has-left-space': !hideBackButton, 'has-right-space': content?.rightContent }"
>
	<ng-content></ng-content>
</div>

<ng-container *ngIf="content">
	<div class="center-content" *ngIf="content.title || content.subTitle">
		<obg-seo-tag-container
			[disableHeaderTag]="disableHeaderTag"
			[content]="content.title"
			class="primary-toolbar-title"
		></obg-seo-tag-container>
		<span [innerHtml]="content.subTitle" class="primary-toolbar-subtitle"></span>
	</div>

	<button
		*ngIf="content.rightContent as rightContent"
		class="right-content"
		color="primary"
		mat-flat-button
		[attr.test-id]="rightContent.testId"
		(click)="rightContentClick.emit($event)"
	>
		<span class="right-content-text" [innerHtml]="rightContent.title"></span>
		<span *ngIf="rightContent.iconClass" [class]="rightContent.iconClass" test-id="right-content-icon"></span>
	</button>
</ng-container>
